import { render } from "./navigation-link.vue?vue&type=template&id=41b5957d"
import script from "./navigation-link.vue?vue&type=script&lang=js"
export * from "./navigation-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__